import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/qr-code-generator/pages/CalculatorPage";

export const Route = createFileRoute("/qr-code-generator")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/qr-code-generator",
      title: m.qr_meta_title(),
      description: m.qr_meta_description(),
      toolName: m.qr_tool_name(),
      faqs: [
        { q: m.qr_faq_q1(), a: m.qr_faq_a1() },
        { q: m.qr_faq_q2(), a: m.qr_faq_a2() },
        { q: m.qr_faq_q3(), a: m.qr_faq_a3() },
        { q: m.qr_faq_q4(), a: m.qr_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
